export default {
  send: 'Илгээх',
  cancel: 'Цуцлах',
  ok: 'Ok',
  save: 'Хадгалах',
  destroy: 'Устгах',
  removal: 'Устгал',
  add: 'Нэмэх',
  close: 'Хаах',
  comeOut: 'Гарах',
  warning: 'Анхааруулга',
  search: 'Хайх',
  settings: 'Тохиргоо',
  invite: 'Урих',
  back: 'Буцах',
  empty: 'Хоосон',
  edit: 'Засах',
  show: 'Харуулах',
  confirm: 'Баталгаажуулах',
  continue: 'Үргэлжлүүлэх',
  total: 'Нийт',
  subtotal: 'Нийт дүн ',
  nothingFound: 'Юу ч олдсонгүй',
  noData: 'Мэдээлэл байхгүй',
  complete: 'Дуусгах',
  report: 'Тайлан',
  move: 'Очих',
  time: 'Цаг',
  cut: 'Огтлох',
  update: 'Шинэчлэх',
  error: 'Алдаа',
  selectLang: 'Хэл сонгоно уу',
  select: 'Сонгох',
  noAccess: 'Та энэ нөөцөд хандах эрхгүй.',
  resourceNotAvailable: '404 - Нөөц байхгүй.',
  youWantRemove: 'Та үнэхээр устгахыг хүсэж байна уу ',
  enterSearch: 'Хайх нэрээ бичиж эхлэнэ үү',
  saveInExcel: 'Excel руу хадгалах',
  downloadExcel: 'Excel татах',
  saveAndDownload: 'Хадгалаад татах',
  yes: 'Тийм',
  no: 'Үгүй',
  dialog: {
    fullscreen: 'Бүтэн дэлгэц',
    exitFullscreen: 'Бүтэн дэлгэцээс гарах',
    inFullscreen: 'Дэлгэц дүүрэн',
  },
  login: {
    entry: 'Нэвтрэх',
    loginOrEmail: 'Нэвтрэх нэр эсвэл email',
    enterLoginOrEmail: 'Нэвтрэх нэр эсвэл email оруулна уу',
    password: 'Нууц үг',
    enterPassword: 'Нууц үгээ оруулна уу',
    resetPassword: 'Нууц үг сэргээх',
    enter: 'Нэвтрэх',
    userNotFound: 'Хэрэглэгч олдсонгүй',
    sentLetter: 'Таны email рүү захиа илгээгдлээ',
    incorrectLoginOrPassword: 'Нэвтрэх нэр эсвэл нууц үг буруу',
  },
  registry: {
    name: 'Нэр',
    enterName: 'Нэрээ оруулна уу',
    login: 'Нэвтрэх нэр',
    enterLogin: 'Нэвтрэх нэрээ оруулна уу',
    farmName: 'Аж ахуйн нэр',
    enterFarmName: 'Аж ахуйн нэрээ оруулна уу',
    email: 'Email',
    enterEmail: 'Email-ээ оруулна уу',
    innFarm: 'ААН-ийн регистр',
    enterInnFarm: 'Регистрийн дугаарыг оруулна уу',
    createPassword: 'Нууц үг үүсгэх',
    confirmPassword: 'Нууц үгээ баталгаажуулах',
    code: 'Код',
    phone: 'Утас',
    enterPhone: 'Утасны дугаараа оруулна уу',
  },
  personalAccount: {
    title: 'Хувийн хэсэг',
    wantQuit: 'Та үнэхээр гарахыг хүсэж байна уу?',
    fullName: 'Овог нэр',
    changePassword: 'Нууц үг солих',
  },
  changePassword: {
    repeatPassword: 'Нууц үгээ давтана уу',
    enterSamePassword: 'Ижил нууц үг оруулна уу',
    newPassword: 'Шинэ нууц үг',
    changedPassword: 'Таны нууц үг өөрчлөгдлөө. Нэвтрэх хуудсанд очно уу.',
  },
  organizations: {
    title: 'Байгууллагууд',
    organization: 'Байгууллага',
    currentOrganization: 'Одоогийн байгууллага',
    nameOrganization: 'Байгууллагын нэр',
    settingOrganization: 'Байгууллагын тохиргоо',
    typeOrganization: 'Байгууллагын төрөл',
    inn: 'Регистр',
    changeOrganization: 'Байгууллага солих',
    selectOrganization: 'Байгууллага сонгох',
    addOrganization: 'Байгууллага нэмэх',
    newOrganization: 'Шинэ байгууллага',
    farm: 'Аж ахуй',
  },
  fields: {
    title: 'Талбайнууд',
    field: 'Талбай',
    myFields: 'Миний талбайнууд',
    listFields: 'Талбайн жагсаалт',
    addField: 'Талбай нэмэх',
    newField: 'Шинэ талбай',
    deleteField: 'Талбай устгах',
    deletePolygon: 'Полигон устгах',
    addPolygon: 'Полигон нэмэх',
    area: 'Хэмжээ: ',
    areaField: 'Талбайн хэмжээ: ',
    hectare: 'га',
    averageHectare: 'Гектар тутмын дундаж: ',
    editingField: 'Талбай засварлах',
    editField: 'Талбай засах',
    enterAddressYourField: 'Талбайнхаа хаягийг оруулна уу эсвэл газрын зураг дээр дарна уу',
    enterRegion: 'Бүсийг оруулна уу',
    enterDistrict: 'Сум/дүүргийг оруулна уу',
    soilType: 'Хөрсний төрөл',
    nameField: 'Талбайн нэр',
    enterNameField: 'Талбайн нэрээ оруулна уу',
    selectCategory: 'Ангилал сонгох',
    areaYourField: 'Талбайн хэмжээ (га)',
    autoArea: 'Автомат хэмжээ',
    maxSizeField: 'Дээд хэмжээ',
    pairs: 'Пар',
    grade: 'Сорт',
    feedMix: 'Тэжээлийн холимог',
    confirmSowing: 'Тарилтыг баталгаажуулах',
    sowing: 'Тарилт',
    dateSowing: 'Тарилтын огноо',
    volumeSowing: 'Тарилтын хэмжээ',
    noCropData: 'Тарилтын мэдээлэл байхгүй',
    unitMeasure: 'Хэмжих нэгж',
    volumeHarvest: 'Ургацын хэмжээ',
    cleaningDate: 'Хураалтын огноо',
    collection: 'Цуглуулалт',
    amountCollected: 'Цуглуулсан хэмжээ',
    basicInformation: 'Үндсэн мэдээлэл',
    stageGrowth: 'Ургалтын шат:',
    numberField: 'Талбай №',
    shouldNotCross: 'Талбайнууд огтлолцож болохгүй',
    overlapNotAllowed: 'Өөрөө огтлолцохыг хориглоно',
  },
  cycle: {
    title: 'Мөчлөг',
    newCycle: 'Шинэ мөчлөг',
    addCycle: 'Мөчлөг нэмэх',
    removeCycle: 'Мөчлөг устгах',
    currentCycle: 'Одоогийн мөчлөг',
    changeCycle: 'Мөчлөг өөрчлөх',
    editCycle: 'Мөчлөг засах',
    cropAndGrade: 'Таримал ба сорт',
    pairView: 'Пар төрөл',
    cleaning: 'Ургац хураалт',
    confirmCleaning: 'Хураалтыг баталгаажуулах',
    volumeCleaning: 'Хураалтын хэмжээ',
    scheduledCollection: 'Төлөвлөсөн хураалт:',
    harvest: 'Хураалт: ',
    notPlanned: 'Төлөвлөгдөөгүй',
    informationMissing: 'Одоогийн мөчлөгийн мэдээлэл алга',
    predecessor: 'Өмнөх таримал',
    noInformationPredecessor: 'Өмнөхийн тухай мэдээлэл алга',
  },
  region: {
    noDataGraphic: 'График байгуулах өгөгдөл алга',
  },
  weather: {
    title: 'Цаг агаарын мэдээ',
    weather: 'Цаг агаар',
    humidity: 'Чийгшил',
    wind: 'Салхи',
    temperature: 'Температур',
    precipitation: 'Хур тунадас',
    sumPrecipitations: 'Хур тунадасны нийлбэр',
    directionWind: 'Салхины чиглэл',
    dewTemperature: 'Шүүдрийн цэгийн температур',
    atmosphericPressure: 'Агаарын даралт',
    airAndPrecipitation: 'Агаар ба тунадас',
    errorWeather: 'Цаг агаарын мэдээг ачаалахад алдаа!',
    weatherForField: '«Талбай ',
    pressure: 'Даралт',
    windGusts: 'Салхины ширүүсэл',
    short: {
      airTemperature: 'Агаарын темп.',
      dewTemperature: 'Шүүдрийн цэг',
      rainfall: 'Тунадас',
      directionWind: 'Салхины чиг',
      windSpeed: 'Салхины хурд',
    },
  },
  analysis: {
    title: 'Шинжилгээ',
    addAnalysis: 'Шинжилгээ нэмэх',
    listAnalysis: 'Шинжилгээний жагсаалт',
    analysisCollection: 'Шинжилгээ цуглуулалт',
    emptyAnalysis: 'Шинжилгээ алга',
    gridFormation: 'Сүлжээ байгуулах',
    secureNet: 'Сүлжээ бэхлэх',
    routeMapping: 'Маршрут зурах',
    enterData: 'Өгөгдөл оруулах',
    customer: 'ООО «КлеверFarmer»',
    analysisField: 'Талбайн шинжилгээ',
    saveData: 'Өгөгдөл хадгалах',
    sectionNumberOne: 'Эхний хэсгийн дугаар',
    downloadData: 'Өгөгдөл ачаалах',
    startCollecting: 'Цуглуулалт эхлүүлэх',
    workDate: 'Ажлын огноо',
    clearAnalysisTable: 'Шинжилгээний хүснэгтийг цэвэрлэх үү?',
    collectingSamples: 'Автах дээжийн тоо: ',
    collectAnalyses: 'Шинжилгээ цуглуулах',
    routeAnalysisCollector: 'Шинжилгээ цуглуулагчийн маршрутыг харах',
    statusAnalysisCollection: 'Шинжилгээ цуглуулалтын төлөв',
    analysisTable: 'Шинжилгээний хүснэгт',
    dateAnalysis: 'Шинжилгээ цуглуулсан огноо:',
    analysisCollectionDateNotAvailable: 'Шинжилгээ цуглуулалтын огноо алга!',
    fileGeneration: 'Файл үүсгэхийг үргэлжлүүлэх үү?',
    displayed: 'Харагдаж буй үзүүлэлт',
    dateCollection: 'Цуглуулсан огноо: ',
  },
  tableAssay: {
    basicAttributes: 'Үндсэн шинжүүд',
    additionalAttributes: 'Нэмэлт шинжүүд',
    numberEU: '№ ЭУ п/п',
    numberSample: 'Дээжийн дугаар',
    average: 'Дундаж',
  },
  laboratory: {
    title: 'Лаборатори',
    definitionForm: 'Тодорхойлох\nмаягт',
    indicatorsAndMethodologies: 'Агрохимийн үзүүлэлт ба арга зүй',
    dischargeForm: 'Экспорт/импорт маягт',
    testProtocol: 'ТУРШИЛТЫН ПРОТОКОЛ №',
    from: '—',
    nameCustomer: 'Захиалагчийн нэр, хаяг:',
    farmName: 'Аж ахуйн нэр:',
    sampleName: 'Судалгааны объект (дээж)-ын нэр:',
    soil: 'хөрс',
    selectLaboratory: 'Лаборатори сонгох',
    transferSample: 'Дээж авах ба тээвэрлэлт:',
    dateReceipt: 'Объект (дээж) хүлээн авсан огноо:',
    testDate: 'Туршилт явуулсан огноо:',
    settingsAttributes: 'Excel файлын атрибут тохируулах',
    excelAttributes: 'Excel файлын атрибут',
  },
  workLog: {
    title: 'Ажлын бүртгэл',
    addWork: 'Ажил нэмэх',
    date: 'Огноо',
    work: 'Ажил',
    volume: 'Хэмжээ',
    deleteWork: 'Ажлыг устгах уу?',
    typeWorks: 'Ажлын төрөл',
    dateWork: 'Ажил хийсэн огноо',
    newWork: 'Шинэ ажил',
  },
  satelliteMonitoring: {
    title: 'Спутник хяналт',
    areaLimit: 'Талбайн лимит хэтэрсэн',
    connectSatellites: 'Спутник холбох',
    from: ' -с ',
    dataProcessing: {
      first: 'Спутникийн өгөгдөл боловсруулж байна.',
      second: 'Зарим хугацаа шаардаж магадгүй',
    },
  },
  inspections: {
    title: 'Осмотр',
    addTask: 'Осмотрын даалгавар нэмэх',
    addResult: 'Осмотрын үр дүн нэмэх',
    completedInspection: 'Осмотр хийгдсэн',
    changeInspection: 'Осмотр засах',
    inspected: 'Осмотр хийсэн',
    inspect: 'Осмотр хийх',
    resultInspection: 'Осмотрын үр дүн',
    fieldInspection: 'Талбайн осмотр',
    planned: 'Төлөвлөгдсөн',
    completed: 'Дууссан',
    scheduledInspection: 'Төлөвлөсөн осмотр',
    changeView: 'Осмотр засах',
    reviewTask: 'Осмотрын даалгавар',
    inspectionAssignment: 'Осмотрын даалгавар',
    executor: 'Гүйцэтгэгч',
    priority: 'Урьтамж',
    inspectionTime: 'Осмотр хийх хугацаа',
    inspectionDate: 'Осмотрын огноо',
    inspectionReport: 'Осмотрын тайлан',
    reviewPhoto: 'Осмотрын зураг',
    growthStage: 'Ургалтын дэд шат',
    currentStage: 'Одоогийн шат',
    stageNotDefined: 'Шат тодорхойлоогүй',
  },
  incidents: {
    title: 'Тохиолдол',
    addIncident: 'Тохиолдол нэмэх',
    character: 'Тохиолдлын шинж',
    description: 'Тохиолдлын тайлбар',
    photo: 'Тохиолдлын зураг',
    delete: 'Тохиолдлыг устгах',
  },
  history: {
    title: 'Түүх',
    historyFields: 'Талбайн түүх',
  },
  location: {
    title: 'Байршил',
    locationSearch: 'Байршил хайх',
    address: 'Хаяг',
    coordinates: 'Координат',
    position: 'Одоогийн байршил',
    nearestTowns: 'Хамгийн ойрын НГ-ын хаяг',
    width: 'Өргөрөг',
    length: 'Уртраг',
    enterWidth: 'Өргөрөг оруулна уу',
    enterLength: 'Уртраг оруулна уу',
    yourLocation: 'Таны байршил',
    geolocationNotAvailable: 'Геолокаци боломжгүй!',
  },
  groups: {
    withoutGroup: 'Бүлэггүй',
    newGroup: 'Шинэ бүлэг',
    nameNewGroup: 'Шинэ бүлгийн нэр',
    selectGroup: 'Бүлэг сонгох',
    removeGroup: 'Бүлэг устгах',
    massControl: 'Олонлог удирдлага',
    removeFieldsGroup: 'Талбайг бүлгээс устгах уу?',
    createGroup: 'Бүлэг үүсгэх',
    moveGroup: 'Бүлэг рүү шилжүүлэх',
    removeFromGroup: 'Бүлгээс хасах',
    selectedFieldsMoveGroup: 'Үүсгэсний дараа сонгосон талбайнууд тийш шилжинэ',
  },
  sorting: {
    filterAndSorting: 'Шүүлт ба эрэмбэлэлт',
    byDate: 'Огноогоор',
    alphabetically: 'Цагаан толгойгоор',
    square: 'Талбайгаар',
    selectCulture: 'Таримал сонгох',
    byIncrement: 'өсөхөөр',
    byDecreasing: 'буурахаар',
    byAgroChemicalAnalysis: 'Агрохимийн шинжилгээгээр',
    collectionStatus: 'Цуглуулалтын төлөв',
    finished: 'Дууссан',
  },
  reportTypes: {
    reports: 'Тайлангууд',
    cropsReport: 'Тарилт (тайлан)',
    cropsChart: 'Тарилт (диаграм)',
    fieldsReport: 'Талбай (тайлан)',
    fieldAnalysisReport: 'Талбайн шинжилгээний тайлан',
    addReport: 'Тайлан нэмэх',
    yourself: 'Өөрт',
    reportOffice: 'Удирдлагын тайлан',
    uship: 'УСХиП',
    mship: 'МСХиП',
  },
  meteoStations: {
    title: 'Метеостанцууд',
    newStation: 'Шинэ станц',
    myStations: 'Миний станцууд',
    addStation: 'Станц нэмэх',
    stationCapacityAssessment: 'Метеостанцын ажиллах чадварын үнэлгээ',
    evaluationPeriod: 'Үнэлгээний хугацаа',
    graphic: 'График',
    editStation: 'Станц засах',
    editingStation: 'Станц засварлах',
    measured: 'Хэмжсэн:',
    uvIndex: 'UV индекс',
    lighting: 'Гэрэлтэлт',
    lux: 'Люкс',
    sumTemperatures: 'Идэвхтэй температурын нийлбэр',
    sumTemperaturesPeriod: 'Идэвхтэй температурын нийлбэр (хугацааны эхнээс)',
    stationsNotLoaded: 'Алдаа. Метеостанцын өгөгдөл ачаалагдаагүй!',
    days: 'хоног',
    sum: 'Нийлбэр, мм',
    precipitationAmount: 'Тунадасны нийлбэр',
    dailyPrecipitation: 'Өдрийн тунадас',
    oneDay: '1 хоног',
    withGustsUp: 'салхины хүч хүртэл',
    precipitation: 'Тунадас, мм',
    height: 'Өндөр',
    timeZone: 'Цагийн бүс',
    model: 'Станцын загвар',
    surveyMethod: 'Судалгааны арга',
    modules: 'Станцын модулиуд',
    ip: 'IP/Host',
    port: 'Порт',
    id: 'Станцын өвөрмөц таних дугаар',
    topic: 'Өгөгдөл авах topic',
    addSensor: 'Мэдрэгч нэмэх',
    measurementHorizonsTemperature: 'Хөрсний температурын хэмжилтийн түвшин',
    measurementHorizonsHumidity: 'Хөрсний чийгийн хэмжилтийн түвшин',
    observationArchive: 'Ажиглалтын архив',
    collectedData: 'Хуримтлагдсан өгөгдөл',
    noDataAvailable: 'Хадгалах өгөгдөл алга',
    collected: 'Хуримтлагдсан',
    dailyRates: 'Өдрийн',
    station: 'Хур.Метеостанц_',
    indexAndIllumination: 'UV индекс ба гэрэлтэлт',
    date: 'Огноо/Цаг',
    stationArchive: 'Арх.Метеостанц',
    requests: 'Хүсэлтүүд',
  },
  areas: {
    title: 'Районууд',
    area: 'Район',
    nameArea: 'Районы нэр',
    myAreas: 'Миний районууд',
    localities: 'Суурин газрууд',
    region: 'Бүс',
    districtAdministration: 'Районы захиргаа',
    regionalAdministration: 'Бүсийн захиргаа',
    couldNotDetermine: 'Бүс тодорхойлж чадсангүй! Өөрөө сонгоно уу!',
  },
  directories: {
    title: 'Лавлах',
    workManual: 'Ажлын лавлах',
    machineryAndEquipment: 'Машин, агрегат',
    typeWork: 'Ажлын төрөл',
    measurementUnit: 'Хэмжих нэгж',
    attributes: 'Атрибутууд',
  },
  attributes: {
    attributeRemoval: 'Атрибут устгах',
    wantRemoveAttributes: 'Бүх атрибутыг үнэхээр устгах уу?',
    jobAttributes: 'Ажлын атрибутууд',
    typeWork: 'Ажлын төрөл',
    title: 'Гарчиг',
    enterTitle: 'Гарчиг оруулна уу',
    listItemHeader: 'Жагсаалтын элементийн гарчиг',
    addListItem: 'Жагсаалтын элемент нэмэх',
    addAttribute: 'Атрибут нэмэх',
    settingAttributes: 'Атрибутын тохиргоо',
  },
  machineryAndEquipment: {
    name: 'Нэр',
    number: 'ГРЗ (улсын дугаар)',
    type: 'Техникийн төрөл',
  },
  agroChemicalExamination: {
    title: 'Агрохимийн үзлэг',
  },
  act: {
    actNumber: 'Акт № ',
    removalAct: 'Акт устгах',
    wantDeleteAct: 'Актыг устгах уу?',
    selectionAct: 'Дээж авах акт',
    annexAct: 'Дээж авах актын хавсралт',
    sampleTags: 'Дээжийн шошго',
    next: 'Дараах',
    sendingLaboratory: 'Лабораторид илгээх',
    sendLaboratory: 'Лабораторид илгээх',
    documents: 'Баримт бичиг:',
    listDocuments: 'Баримтын жагсаалт',
    readyDocuments: 'Бэлэн баримтууд',
    downloadReadyDocuments: 'Бэлэн баримтуудыг татан авч лабораторид илгээнэ үү',
    dataSelectionAct: 'Дээж авах актыг бүрдүүлэх мэдээлэл бөглөнө үү',
    testData: 'Туршилтын мэдээлэл',
    actSelectionNumber: 'Дээж авах актын дугаар',
    testDate: 'Туршилтын огноо',
    pickerName: 'Дээж авагчийн овог нэр',
    namePresent: 'Оролцогчийн овог нэр',
    nameCustomer: 'Захиалагчийн овог нэр',
    testLayer: 'Судлагдах хөрсний давхарга, см',
    sampleSendingData: 'Лабораторид дээж илгээх өгөгдлийг бөглөнө үү',
  },
  map: {
    title: 'Газрын зураг',
    maps: 'Газрын зургууд',
    yandexMaps: 'Yandex газрын зураг',
    googleMaps: 'Google газрын зураг',
    selectCard: 'Газрын зургийн төрлийг сонгох',
    regionalOffice: 'Росреестр',
    undoChanges: 'Өөрчлөлтийг буцаах',
    gridType: 'Сүлжээний төрөл',
    gridArea: 'Сүлжээний талбай: ',
    tiltAngle: 'Хазайлтын өнцөг: ',
    scale: 'Хэмжээс: ',
    changePoint: 'Цэгийн байршлыг өөрчлөх',
    combinePlots: 'Хэсгүүдийг нэгтгэх',
    changeNumberPlot: 'Хэсгийн дугаарыг өөрчлөх',
    numberPlot: 'Элементар хэсгийн дугаар',
    removePlot: 'Хэсгийг устгах',
    cancelStep: 'Алхмыг буцаах',
    clearRoute: 'Маршрутыг арилгах',
    positioning: 'Байршил тогтоох',
    cancelPosition: 'Байршлыг цуцлах',
    startingNew: 'Шинээр эхлэх',
    fixedPosition: 'Байршил бэхлэх',
    saveMap: 'Хэвлэх газрын зургийг хадгалах',
    addDot: 'Цэг нэмэх',
    pointChosen: 'Шугамын нэг цэг аль хэдийн сонгогдсон байна!',
    simplifyContour: 'Контурыг хялбаршуулах',
    accuracy: 'Нарийвчлал',
    plots: 'хэсэг(үүд)',
    route: 'Маршрут',
    matrix: 'Матриц',
    curtain: 'Хөшиг',
    notifications: {
      deviceNotNavigation: 'Алдаа! Төхөөрөмжид навигаци байхгүй',
      waitLocation: 'Байршил тогтоохыг хүлээнэ үү!',
      collectionAnalysis: 'Талбай дээр шинжилгээ цуглуулалт хийгдсэн!',
      alreadyCollectionAnalysis: 'Полигонд шинжилгээ цуглуулалт аль хэдийн хийгдсэн!',
      polygonNotFound: 'Одоогийн байрлалд полигон олдсонгүй!',
      dotInField: 'Алдаа! Цэгийг талбайн дотор тавина уу!',
      locationOnMap: 'Осмотр хийх газрын цэгийг тавина уу!',
      placeOnMap: 'Газрын зураг дээр цэг тавина уу!',
    },
  },
  baseValidation: {
    requiredField: 'Заавал бөглөх талбар',
    incorrectEmail: 'Зөв E-mail оруулна уу',
    passwordsDontMatch: 'Оруулсан нууц үгс таарахгүй байна',
    minCharacters: {
      start: 'Хамгийн бага',
      end: 'тэмдэгт',
    },
    maxCharacters: {
      start: 'Хамгийн их',
      end: 'тэмдэгт',
    },
    minValue: 'Хамгийн бага утга ',
    maxValue: 'Хамгийн их утга ',
    numberValue: 'Утга тоо байх ёстой',
  },
  satellite: {
    title: 'Спутник',
    imageDate: 'Зургийн огноо',
    cloud: 'Үүлшилт',
    representation: 'Дүрслэл',
    applyAllFields: 'Бүх талбайд хэрэглэх',
    layer: 'Давхарга',
    fieldChronology: 'Талбайн цаглал',
  },
  agroChemicalAnalysis: {
    title: 'Агрохимийн шинжилгээ',
    fieldAverage: 'Талбайн дундаж',
    indicator: 'Үзүүлэлт',
    interpolation: 'Интерполяци',
    noAnalysis: 'Шинжилгээ алга',
    notStarted: 'Эхлээгүй',
    inProcess: 'Явцтай',
    finished: 'Дууссан',
    completed: 'Бүрэн',
  },
  cabinetFarms: {
    title: 'Аж ахуйн самбар',
    nameFarms: 'Аж ахуйн нэрс',
    organizationProfile: 'Байгууллагын профиль',
  },
  users: {
    title: 'Хэрэглэгчид',
    user: 'Хэрэглэгч',
    newUser: 'Шинэ хэрэглэгч',
    superManager: 'Супер админ',
    inviteUsers: 'Хэрэглэгч урих',
    name: 'Нэр',
    removalUser: 'Хэрэглэгч устгах',
    wantDeleteUser: 'Хэрэглэгчийг устгах уу?',
    roles: 'Эрхүүд',
    notChangeRoles: 'Өөрийн эрхүүдийг өөрчлөх боломжгүй',
    invitationSent: 'Урилга илгээгдлээ',
  },
  managementReport: {
    title: 'Аж ахуйн тайлан',
    nameFarm: 'Аж ахуйн нэр',
    culture: 'Таримал',
    area: 'Талбай, га',
  },
  fieldAnalysisReport: {
    yearsAnalysis: 'Шинжилгээний жил',
    requestReport: 'Тайлан хүсэх',
    moreInformation: 'Нэмэлт мэдээлэл',
    typesDryLand: 'ХАА-н газрын төрлүүд',
    data: {
      title: 'Өгөгдөл',
      yearMissing: 'оны хувьд байхгүй!',
    },
    intro: 'Оршил',
    conclusion: 'Дүгнэлт',
    file: {
      start: 'Талбайн шинжилгээний тайлан ',
      end: ' он.zip',
    },
  },
  tableStatuses: {
    veryLow: 'Маш бага',
    low: 'Бага',
    normal: 'Хэвийн',
    average: 'Дунд',
    high: 'Өндөр',
    veryHigh: 'Маш өндөр',
  },
  spectrogramIndicators: {
    veryLow: 'Маш бага',
    low: 'Бага',
    average: 'Дунд',
    high: 'Өссөн',
    veryHigh: 'Өндөр',
  },
  cropDistribution: {
    title: 'Таримал, сортоор тараалт',
    withoutGrade: 'Сортгүй',
    noDataForChart: 'График байгуулах өгөгдөл алга',
  },
  tasks: {
    title: 'Даалгавар',
    tasksAndReports: 'Даалгавар ба тайлан',
  },
  datePicker: {
    incorrectDate: 'Огноо буруу байна',
    sequenceBroken: 'Өдрүүдийн дараалал алдагдсан',
    rangeDate: 'Огнооны муж',
  },
  layerTypes: {
    notShow: 'Харуулахгүй',
    naturalColor: 'Байгалийн өнгө',
  },
  presentationTypes: {
    index: 'Индекс',
    homogeneity: 'Жигд байдал',
    dynamics: 'Динамик',
  },
  dangerousPhenomena: {
    title: 'Аюултай үзэгдэл',
    check: 'Шалгах',
    date: 'Огноо',
    type: 'Төрөл',
    dataMissing: 'Өгөгдөл алга',
    selectPeriodAndType: 'Хугацаа ба төрлийг сонгоно уу',
  },
  indicators: {
    n: 'Азот (N)',
    p: 'Фосфор (P)',
    k: 'Кали (K)',
    s: 'Хүхэр (S)',
    ph: 'pH',
    humus: 'Гумус',
    salinization: 'Давсжилт',
    ca: 'Кальци (Ca)',
    mg: 'Магни (Mg)',
    fe: 'Төмөр (Fe)',
    mn: 'Марганец (Mn)',
    zn: 'Цайр (Zn)',
    cu: 'Зэс (Cu)',
    b: 'Бор (B)',
    mo: 'Молибден (Mo)',
    na: 'Натри (Na)',
    cl: 'Хлор (Cl)',
    co: 'Кобальт (Co)',
    soilCompaction: 'Хөрсний нягтрал',
    salinizationType: 'Давсжилтын төрөл',
  },
  optionsIndicators: {
    'Стандартный метод': 'Стандарт арга',
    'по Тюрину и Коноваловой': 'Тюрин, Коноваловагийн дагуу',
    'по Корнфилду': 'Корнфилдын дагуу',
    'по Кравкову': 'Кравковын дагуу',
    'по Мачигину': 'Мачигины дагуу',
    'по Кирсанову': 'Кирсановын дагуу',
    'по Чирикову': 'Чириковын дагуу',
    'по Эгнеру Римму': 'Эгнер–Риммийн дагуу',
    'по Маслову': 'Масловын дагуу',
    Сульфатное: 'Сульфат',
    Хлоридное: 'Хлорид',
    'Сульфатно-хлоридное': 'Сульфат-хлорид',
    'Хлоридно-сульфатное': 'Хлорид-сульфат',
    'Содово-хлоридный': 'Натри-хлорид',
    'Содово-сульфатный': 'Натри-сульфат',
    'Хлоридно-содовый': 'Хлорид-натри',
    'Сульфатно-содовый': 'Сульфат-натри',
    'Сульфатно-хлоридный гидрокарбонатный': 'Сульфат-хлорид бикарбонат',
    Карбонатное: 'Карбонат',
  },
  suffixes: {
    massFraction: 'мг/кг',
    density: 'г/см³',
    pressure: 'кг/см2',
    percent: '%',
    degree: '°C',
    millimetre: 'мм',
    metersPerSecond: 'м/с',
    degreeAngle: '°',
    atmosphericPressure: 'мм м.у.б',
    precipitation: 'мм/ц',
    centimeter: 'см',
  },
  labelsAttributeType: {
    string: 'Текст',
    text: 'Олон мөрт текст',
    flag: 'Туг',
    list: 'Жагсаалт',
  },
  machineryTypeLabel: {
    selfPropelled: 'Өөрөө явагч',
    trailer: 'Чиргүүл',
  },
  fieldsCategories: {
    cropland: 'Пашня',
    hayfield: 'Сенокос',
    permanentCrops: 'Олон наст таримал',
    pasture: 'Бэлчээр',
    fallowLand: 'Пар',
  },
  saveInImage: {
    inJpeg: 'JPEG-д хадгалах',
    inPng: 'PNG-д хадгалах',
    inSvg: 'SVG-д хадгалах',
  },
  textUnits: {
    tn: 'т',
    cwt: 'ц',
    kg: 'кг',
    num: 'ш',
    su: 'cwt',
    suha: 'суул. нэгж',
    tnha: 'т/га',
    cwtha: 'ц/га',
    kgha: 'кг/га',
    numha: 'ш/га',
  },
  textFallows: {
    clear: 'Цэвэр',
    occupied: 'Завсартай',
    half: 'Хагас пар',
    sideral: 'Сидерийн',
  },
  assayType: {
    gost: 'ГОСТ',
    bionic: 'Бионик',
  },
  roteLabel: {
    auto: 'Автомат',
    hand: 'Гар',
  },
  errorsPolygon: {
    selectPointPolygon: 'Цэг агуулсан полигоныг сонгоно уу!',
    selectActivePolygon: 'Идэвхтэй полигон сонгоно уу!',
    notMatchNumber: 'Импортын алдаа! Импортолсон полигонуудын тоо одоогийнхтой таарахгүй байна!',
    checkPolygonsMatch: 'Импортын алдаа! Полигоны таарамжийг шалгана уу!',
    errorSelectRoute: 'Алдаа! Маршрут сонгоно уу!',
    errorRequiredFields: 'Алдаа! Шаардлагатай талбаруудыг бөглөнө үү!',
    typeImportError: 'Төрлийн импортын алдаа! Төрлийг шалгана уу',
    initializationError: 'Инициализацийн алдаа!',
  },
  seriesTypes: {
    calm: 'Нам гүм',
    lightWind: 'Зөөлөн салхи',
    lightBreeze: 'Сэвэлзүүр салхи',
    weakWind: 'Сул салхи',
    moderateWind: 'Дунд зэргийн салхи',
    freshBreeze: 'Сэрүүн салхи',
    nearStorm: 'Шуургын өмнөх',
    storm: 'Шуурга',
    strongWind: 'Хүчтэй салхи',
    fierceStorm: 'Хүчтэй шуурга',
    hurricane: 'Хар салхи',
  },
  highcharts: {
    loading: 'Ачаалж байна...',
    months: {
      January: 'Нэгдүгээр сар',
      February: 'Хоёрдугаар сар',
      March: 'Гуравдугаар сар',
      April: 'Дөрөвдүгээр сар',
      May: 'Тавдугаар сар',
      June: 'Зургаадугаар сар',
      July: 'Долоодугаар сар',
      August: 'Наймдугаар сар',
      September: 'Есдүгээр сар',
      October: 'Аравдугаар сар',
      November: 'Арваннэгдүгээр сар',
      December: 'Арванхоёрдугаар сар',
    },
    weekdays: {
      Sunday: 'Ням',
      Monday: 'Даваа',
      Tuesday: 'Мягмар',
      Wednesday: 'Лхагва',
      Thursday: 'Пүрэв',
      Friday: 'Баасан',
      Saturday: 'Бямба',
    },
    shortMonths: {
      January: '1-р сар',
      February: '2-р сар',
      March: '3-р сар',
      April: '4-р сар',
      May: '5-р сар',
      June: '6-р сар',
      July: '7-р сар',
      August: '8-р сар',
      September: '9-р сар',
      October: '10-р сар',
      November: '11-р сар',
      December: '12-р сар',
    },
    rangeSelectorFrom: '-с',
    rangeSelectorTo: '- хүртэл',
    rangeSelectorZoom: 'Хугацаа',
    downloadPNG: 'PNG татах',
    downloadJPEG: 'JPEG татах',
    downloadPDF: 'PDF татах',
    downloadSVG: 'SVG татах',
    printChart: 'График хэвлэх',
    resetZoom: 'Томруулгыг дахин тохируулах',
    viewFullscreen: 'Бүтэн дэлгэц',
    exitFullscreen: 'Ердийн горим',
    errorSaveFile: 'Файл хадгалахад алдаа гарлаа',
  },
  timezone: {
    utc2: 'UTC+2, Калининград',
    utc3: 'UTC+3, Москва',
    utc4: 'UTC+4, Астрахань',
    utc5: 'UTC+5, Екатеринбург',
    utc6: 'UTC+6, Омск',
    utc7: 'UTC+7, Красноярск',
    utc8: 'UTC+8, Иркутск',
    utc9: 'UTC+9, Якутск',
    utc10: 'UTC+10, Владивосток',
    utc11: 'UTC+11, Магадан',
  },
  dangerousPhenomenaTypes: {
    dryWind: 'Хуурай салхи',
    atmosphericDrought: 'Агаарын ган',
    frost: 'Хяруу',
    heavyDownpour: 'Аадар бороо',
    heavyRain: 'Их бороо',
  },
  incidentTypes: {
    disease: 'Өвчин',
    pest: 'Хортон шавьж',
    technological: 'Технологийн алдаа',
    flooding: 'Үер',
    lodging: 'Уналт',
    weed: 'Хогийн ургамал',
    other: 'Бусад',
  },
  router: {
    error403: 'Алдаа 403',
    main: 'KleverFarmer',
    districts: 'Районууд',
    organizations: 'Байгууллагууд',
    fields: 'Талбай ба тарилт',
    agroSurvey: 'Агрохимийн үзлэг',
    worksManual: 'Ажлын лавлах',
    machines: 'Машин, агрегат',
    constructionLog: 'Ажлын бүртгэл',
    fieldHistory: 'Талбайн түүх',
    satellite: 'Спутникийн өгөгдөл',
    scouting: 'Талбайн осмотр',
    meteos: 'Метеостанцууд',
    stationPerformance: 'Станцын ажиллагааны үнэлгээ',
    organizationProfile: 'Байгууллагын профиль',
    cropStructure: 'Тарилтын бүтэц',
    speciesTable: 'Тарилтын бүтэц / хүснэгтэн',
    fieldsTable: 'Талбайн жагсаалт / хүснэгтэн',
    fieldsAnalysisReport: 'Талбайн шинжилгээний тайлан',
    login: 'Нэвтрэх',
    restorePassword: 'Нууц үг сэргээх',
    invite: 'Урилга',
    error404: 'Алдаа 404',
  },
  httpErrors: {
    noAccess: 'Серверт хандах боломжгүй.',
    accessDenied: 'Алдаа 403: Хандалт хориглосон.',
    error404: 'Алдаа 404',
    fieldFillingError: 'Талбаруудыг бөглөхдөө алдаа гарлаа!',
    manyRequests: 'Алдаа 429: Хэт олон хүсэлт.',
    unexpectedErrorOccurred: 'Тодоогүй алдаа гарлаа! Админтай холбогдоно уу!',
    defaultError: 'Тодорхойгүй алдаа гарлаа.',
  },
};
